import { FontWeight } from 'lib/styles';
import { Text } from 'styles/themeColors';

const customerColumns = [
  {
    title: 'Customer Name',
    field: 'fullName',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: '12%',
    removable: false
  },
  {
    title: 'Customer Phone',
    field: 'phone',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: '12%'
  },
  {
    title: 'Company Email',
    field: 'email',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: '15%'
  },
  {
    title: 'Compliance check',
    field: 'dowJonesStatus',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: '12%',
    removable: false
  },
  {
    title: 'Company Legal Name',
    field: 'companyName',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: '12%'
  },
  {
    title: 'OFMP Company Name',
    field: 'displayName',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: '12%'
  },
  {
    title: 'Country',
    field: 'countryName',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: '10%',
    hiddenByColumnsButton: true
  },
  {
    title: 'Created Date',
    field: 'createdDate',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: '10%',
    defaultSort: 'desc'
  },
  {
    title: 'Company name input by customer',
    field: 'companyNameByCustomer',
    headerStyle: { color: Text.primary, fontWeight: FontWeight.bold },
    width: '10%',
    hidden: true,
    hiddenByColumnsButton: true
  }
];

export default customerColumns;
